<template>
<div class="chapter">
<div class="inner_page">
<p class="htit1"><a id="page_i"></a>Royal Mysteries of</p>
<p class="htit2">the Anglo-Saxons</p>
<p class="htit2">and Early Britain</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?8069d7ea